<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label"
      @remove="onClickFilterRemove"
    >
      <div>
        <vs-select class="w-full" autocomplete v-model="half" @change="change" :disabled="readonly">
          <vs-select-item v-for="(half, index) in halfList" :key="index" :text="half.text" :value="half.value" />
        </vs-select>
      </div>
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="labelHidden" :columns="options['gridTemplateColumns']">
      <div>
        <vs-select class="w-full xl:w-32" autocomplete v-model="half" @change="change" :disabled="readonly">
          <vs-select-item v-for="(half, index) in halfList" :key="index" :text="half.text" :value="half.value" />
        </vs-select>
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";

export default {
  name: "SearchYearHalf",
  components: {
    SearchFilterItem,
    SearchLabelBody,
  },
  props: {
    label: {
      default: "반기",
      type: String,
    },
    value: [String, Number],
    setRef: Function,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          'half': '',
        }
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      this.half = value;
    },
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
    defaultValue () {
      return this.options && this.options['default'] ? this.options['default'] : "";
    },
    initData() {
      const defaultValue = this.defaultValue;
      const _query_keys = Object.keys(this.query)
      const query = this.$route.query;
      const half = query[_query_keys[0]];
      if (half) {
        try {
          return {
            half: half || defaultValue,
          };
        } catch (e) {}
      }
      return {
        half: defaultValue,
      };
    },
    halfList() {
      return [
        { text: '상반기', value: '상반기' },
        { text: '하반기', value: '하반기' },
      ];
    },
    labelHidden() {
      // labelHiddenResolution 이상의 해상도에서는 label 을 보여주지 않음
      const target = this.labelHiddenResolution;
      const screens = this.$viewport.screens;
      const start = screens.indexOf(target);
      if (start > -1) {
        for (let i = start; i < screens.length; i++) {
          if (this.$viewport.screen === screens[i]) {
            return true;
          }
        }
      }
      return !this.label;
    },
    labelHiddenResolution () {
      return this.options.labelHiddenResolution || 'none'
    }
  },
  data() {
    return {
      half: "",
    };
  },
  created() {
    this.half = this.initData.half;
    this.$emit("input", this.half);
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
  },
  methods: {
    change(data) {
      this.$emit("input", data);
    },
    onClickFilterRemove () {
      this.half = this.defaultValue;
      this.$emit("input", this.half);
    }
  },
};
</script>
